import React from 'react';
import { Menu } from '@trussworks/react-uswds';

export function USWDSMenu(props) {
  return <Menu {...props} />;
}
